import { Flex, SimpleGrid, Switch, Text } from "@mantine/core";
import { Controller, useFieldArray } from "react-hook-form";

const EmailNotificationsSection = ({ control }) => {
  const { fields } = useFieldArray({ control, name: "notifications" });

  if (fields.length === 0) {
    return (
      <Text size="sm" c="dimmed" ta="center">
        No email notification settings available.
      </Text>
    );
  }

  return (
    <SimpleGrid cols={2} spacing="xl" verticalSpacing={0}>
      {fields.map((field, index) => (
        <Flex
          key={field.id}
          justify="space-between"
          align="center"
          py="xs"
          style={{
            borderBottom: "1px solid var(--mantine-color-secondary-1)",
          }}
        >
          <Text size="sm">{field.label || field.emailType}</Text>
          <Controller
            name={`notifications.${index}.enabled`}
            control={control}
            render={({ field: f }) => (
              <Switch
                thumbIcon={" "}
                checked={!!f.value}
                onChange={(e) => f.onChange(e.currentTarget.checked)}
              />
            )}
          />
        </Flex>
      ))}
    </SimpleGrid>
  );
};

export default EmailNotificationsSection;
